<template>
  <el-form
    ref="formData"
    :model="formData"
    :rules="rules"
    size="small"
    label-position="rigth"
  >
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item
          :label="$l('INDEX.form_label_containerName') || '箱型'"
          prop="containerCode"
          label-width="130px"
        >
          <dict-select
            filterable
            v-model="formData.containerCode"
            url="/factory/masterContainer/dictSelect"
            :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
            size="small"
            clearable
            :selectedLabel.sync="formData.containerName"
            @change="onContainerChange"
          >
          </dict-select>
        </el-form-item>
      </el-col>
      <el-col :span="10">
        <el-button
          type="primary"
          size="small"
          @click="openExtendParameterDialog()"
        >
          {{ title }}
        </el-button>
      </el-col>
    </el-row>
    <ExtendParameterDialog
      ref="extendParameter"
      v-if="extendParameterDialogVisible"
      :visible.sync="extendParameterDialogVisible"
      :title="title"
      :formData.sync="formData"
      @change="bookingVolumeChange"
    />
  </el-form>
</template>
<script>
import validate from '@/libs/util.validate'
import ExtendParameterDialog from './extendParameterDialog.vue'
export default {
  components: { ExtendParameterDialog },
  data() {
    return {
      formData: {
        containerBookingVolume: undefined,
        extendParameterLength: 0,
        extendParameterWidth: 0,
        extendParameterHeight: 0,
        extendParameterType: 'DEFAULT',
      },
      title: this.$l('INDEX.form_set_up_extendParameter') || '设置订舱放大系数',
      data: {},
      extendParameterDialogVisible: false,
      rules: {
        containerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择箱型',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    async formValidate() {
      return await validate.formValidate([this.$refs.formData])
    },
    async onContainerChange() {
      this.resetFormData()
      const { containerCode } = this.formData
      if (containerCode) {
        const res = await this.$api.masterContainerDetailApi({ containerCode })
        this.data = { ...this.formData, ...res.body }
      }
      this.$emit('change', { ...this.data })
      if (!this.formData.containerBookingVolume) {
        this.bookingVolumeChange()
      }
    },
    bookingVolumeChange(data) {
      this.$emit('changeBookingVolume', data)
    },
    reset() {
      this.formData = {
        containerBookingVolume: undefined,
        extendParameterLength: 0,
        extendParameterWidth: 0,
        extendParameterHeight: 0,
        extendParameterType: 'DEFAULT',
      }
      this.onContainerChange()
    },
    resetFormData() {
      this.formData.containerBookingVolume = undefined
      this.formData.extendParameterLength = 0
      this.formData.extendParameterWidth = 0
      this.formData.extendParameterHeight = 0
      this.formData.extendParameterType = 'DEFAULT'
    },
    openExtendParameterDialog() {
      if (!this.formData.containerCode) {
        this.$message.warning('请选择箱型')
        return
      }
      this.extendParameterDialogVisible = true
    },
  },
}
</script>
